<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 100px">
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-primary">Total Sales</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalSales | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-warning">Total Retur</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalRetur | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total HPP</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalCOGS - totalCOGSRetur | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-success">Total Laba Kotor</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalMargin | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total HPP Sales</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalCOGS | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
          </div>
          <div class="col-md-3">
            <div class="card report-card">
              <div class="card-body">
                <div class="float-right">
                  <i class="dripicons-user-group report-main-icon"></i>
                </div>
                <h5><span class="badge badge-info">Total HPP Retur</span></h5>
                <h3 class="my-3">
                  <span v-if="loadingSales === false">
                    <div class="loadingio-spinner-bars-km984sg9h2">
                      <div class="ldio-m41ff6uvz8">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    {{ totalCOGSRetur | currency }}
                  </span>
                </h3>
              </div>
              <!--end card-body-->
            </div>
            <!--end card-->
          </div>
        </div>
        <div class="row">
            <div class="col-md-12">
              <div class="top-list-small-toolbar">
                  <div>
                      <h4 class="text-primary">Laporan Laba Kotor</h4>
                      <div class="form-inline">
                        <span><b>Company:</b></span>
                        <select v-model="company_no" class="form-control">
                          <option value="">-- All --</option>
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                        <span><b>Date:</b></span>
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button type="button" class="btn btn-sm btn-soft-primary" @click="checkDetail">Process</button>
                          <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                        <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-print" aria-hidden="true"></i> Print
                        </button>
                        <div class="dropdown-menu" aria-labelledby="print">
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                        </div>
                      </div>
                  </div>
              </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#raw" data-toggle="tab" aria-expanded="false" class="nav-link active">Raw</a></li>
                            <li class="nav-item"><a href="#sales-data-raw" data-toggle="tab" aria-expanded="false" class="nav-link">Sales & Journal</a></li>
                            <li class="nav-item"><a href="#sales-product" data-toggle="tab" aria-expanded="false" class="nav-link">Data</a></li>
                            <li class="nav-item"><a href="#summary" data-toggle="tab" aria-expanded="false" class="nav-link">Summary</a></li>
                            <li class="nav-item"><a href="#raw-type" data-toggle="tab" aria-expanded="false" class="nav-link">Raw Type</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="raw">
                              <div v-for="i in filterData" :key="i.id">
                                  <h5 class="text-center" style="margin-top: 20px"><b>{{ i.name }}</b></h5>
                                  <hr/>
                                  <!-- MAIN -->
                                  <div class="table-responsive" v-if="i.id !== 10 && i.id !== 12">
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                        <thead>
                                            <th>#</th>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Ref No.</th>
                                            <th>Product</th>
                                            <th>Qty</th>
                                            <th>Uom</th>
                                            <th class="text-right">HPP</th>
                                            <th class="text-right">Total HPP</th>
                                            <!-- <th class="text-right">Journal HPP</th> -->
                                            <th class="text-right">Total</th>
                                            <th class="text-right">Profit</th>
                                            <th class="text-right">%</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="a in i.data" :key="a.id">
                                                <td>
                                                  <span>
                                                    <label class="form-checkbox">
                                                      <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selected" v-if="a.type === 'sales'">
                                                      <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selectedR" v-else>
                                                    </label>
                                                  </span>
                                                </td>
                                                <td>{{ a.date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td>
                                                  <span class="badge badge-success" v-if="a.type === 'sales'">{{ a.type }}</span>
                                                  <span class="badge badge-warning" v-else>{{ a.type }}</span>
                                                </td>
                                                <td>
                                                  <b class="text-ref-sales" @click="showSaleNo(a.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</b>
                                                </td>
                                                <td><b>[{{ a.product_no }}]</b> {{ a.description }}</td>
                                                <td>{{ a.qty}}</td>
                                                <td>{{ a.uom_id }}</td>
                                                <td class="text-right">{{ a.cost | currency }}</td>
                                                <td class="text-right">
                                                  {{ a.total_cost | currency }}
                                                </td>
                                                <!-- <td class="text-right">
                                                  <span v-if="a.total_cost !== a.total_journal_hpp" class="badge badge-danger">{{ a.total_journal_hpp | currency }}</span>
                                                  <span v-else>{{ a.total_journal_hpp | currency }}</span>
                                                </td> -->
                                                <td class="text-right">
                                                  <span v-if="a.type == 'retur'">({{ a.total | currency }})</span>
                                                  <span v-else>{{ a.total | currency }}</span>
                                                </td>
                                                <td class="text-right">
                                                  <span class="badge badge-danger" v-if="a.margin < 0">{{ a.margin | currency }}</span>
                                                  <span v-else>{{ a.margin | currency }}</span>
                                                </td>
                                                <td class="text-right">
                                                  <span class="badge badge-danger" v-if="a.margin_percentage < 0">{{ a.margin_percentage | currency }}</span>
                                                  <span v-else>{{ a.margin_percentage | currency }}</span>
                                                </td>
                                            </tr>
                                          </tbody>
                                          <tfoot>
                                            <tr>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td>{{ i.total_qty | currency }}</td>
                                              <td></td>
                                              <td></td>
                                              <td class="text-right"><b>{{ i.total_cost | currency }}</b></td>
                                              <!-- <td class="text-right"><b>{{ i.total_journal | currency }}</b></td> -->
                                              <td class="text-right"><b>{{ i.total | currency }}</b></td>
                                              <td class="text-right"><b>{{ i.total_margin | currency }}</b></td>
                                              <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                        <thead>
                                            <th>#</th>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Ref No.</th>
                                            <th>Product</th>
                                            <th>Qty</th>
                                            <th>Uom</th>
                                            <th class="text-right">HPP</th>
                                            <th class="text-right">Total HPP</th>
                                            <!-- <th class="text-right">Journal HPP</th> -->
                                            <th class="text-right">Total</th>
                                            <th class="text-right">Profit</th>
                                            <th class="text-right">%</th>
                                        </thead>
                                        <tbody>
                                          <tr v-for="a in i.data_retur" :key="a.id">
                                            <td>
                                              <span>
                                                <label class="form-checkbox">
                                                  <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selected" v-if="a.type === 'sales'">
                                                  <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selectedR" v-else>
                                                </label>
                                              </span>
                                            </td>
                                            <td>{{ a.date | dateFormat('DD/MM/YYYY') }}</td>
                                            <td>
                                              <span class="badge badge-success" v-if="a.type === 'sales'">{{ a.type }}</span>
                                              <span class="badge badge-warning" v-else>{{ a.type }}</span>
                                            </td>
                                            <td>
                                              <b class="text-ref-sales" @click="showSaleNo(a.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</b>
                                            </td>
                                            <td><b>[{{ a.product_no }}]</b> {{ a.description }}</td>
                                            <td>{{ a.qty}}</td>
                                            <td>{{ a.uom_id }}</td>
                                            <td class="text-right">{{ a.cost | currency }}</td>
                                            <td class="text-right">{{ a.total_cost | currency }}</td>
                                            <!-- <td class="text-right">
                                              <span v-if="a.total_cost !== a.total_journal_return" class="badge badge-danger">{{ a.total_journal_return | currency }}</span>
                                              <span v-else>{{ a.total_journal_return | currency }}</span>
                                            </td> -->
                                            <td class="text-right">{{ a.total | currency }}</td>
                                            <td class="text-right">
                                              <span class="badge badge-danger" v-if="a.margin < 0">{{ a.margin | currency }}</span>
                                              <span v-else>{{ a.margin | currency }}</span>
                                            </td>
                                            <td class="text-right">
                                              <span class="badge badge-danger" v-if="a.margin_percentage < 0">{{ a.margin_percentage | currency }}</span>
                                              <span v-else>{{ a.margin_percentage | currency }}</span>
                                            </td>
                                          </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td>{{ i.total_qty_retur | currency }}</td>
                                              <td></td>
                                              <td></td>
                                              <td class="text-right"><b>{{ i.total_cost_retur | currency }}</b></td>
                                              <!-- <td class="text-right"><b>{{ i.total_journal_return | currency }}</b></td> -->
                                              <td class="text-right"><b>{{ i.total_retur | currency }}</b></td>
                                              <td class="text-right"><b>{{ i.total_margin_retur | currency }}</b></td>
                                              <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                  </div>
                                  <!-- FiberGlass -->
                                  <div class="table-responsive" v-else>
                                    <!-- Table Fiberglass -->
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                        <th>#</th>
                                        <th>Dates</th>
                                        <th>Type</th>
                                        <th>Ref No.</th>
                                        <th>Product</th>
                                        <th>Qty</th>
                                        <th>Uom</th>
                                        <th class="text-right">Total HPP</th>
                                        <!-- <th class="text-right">Total Journal</th> -->
                                        <th class="text-right">Total</th>
                                        <th class="text-right">Profit</th>
                                        <th class="text-right">%</th>
                                      </thead>
                                      <tbody>
                                        <tr v-for="a in i.data" :key="a.id">
                                          <td>
                                            <span>
                                              <label class="form-checkbox">
                                                <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selected" v-if="a.type === 'sales'">
                                                <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selectedR" v-else>
                                              </label>
                                            </span>
                                          </td>
                                          <td>{{ a.date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td>
                                            <span class="badge badge-success" v-if="a.type === 'sales'">{{ a.type }}</span>
                                            <span class="badge badge-warning" v-else>{{ a.type }}</span>
                                          </td>
                                          <td>
                                            <b class="text-ref-sales" @click="showSaleNo(a.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</b>
                                          </td>
                                          <td><b>[{{ a.product_no }}]</b> {{ a.description }}</td>
                                          <td>{{ a.qty}}</td>
                                          <td>{{ a.uom_id }}</td>
                                          <td class="text-right">
                                            <!-- <span v-if="a.type == 'retur'">({{ a.total_cost | currency }})</span> -->
                                            <span>{{ a.total_cost | currency }}</span>
                                          </td>
                                          <!-- <td class="text-right">
                                            <span v-if="a.total_cost !== a.total_journal_hpp" class="badge badge-danger">{{ a.total_journal_hpp | currency }}</span>
                                            <span v-else>{{ a.total_journal_hpp | currency }}</span>
                                          </td> -->
                                          <td class="text-right">
                                            <span v-if="a.type == 'retur'">({{ a.total | currency }})</span>
                                            <span v-else>{{ a.total | currency }}</span>
                                          </td>
                                          <td class="text-right">
                                            <span class="badge badge-danger" v-if="a.margin < 0">{{ a.margin | currency }}</span>
                                            <span v-else>{{ a.margin | currency }}</span>
                                          </td>
                                          <td class="text-right">
                                            <span class="badge badge-danger" v-if="a.margin_percentage < 0">{{ a.margin_percentage | currency }}</span>
                                            <span v-else>{{ a.margin_percentage | currency }}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                      <tfoot>
                                          <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{{ i.total_qty | currency }}</td>
                                            <td></td>
                                            <td class="text-right"><b>{{ i.total_cost | currency }}</b></td>
                                            <td class="text-right"><b>{{ i.total_cost | currency }}</b></td>
                                            <td class="text-right"><b>{{ i.total | currency }}</b></td>
                                            <!-- <td class="text-right"><b>{{ i.total_journal | currency }}</b></td> -->
                                            <td class="text-right"><b>{{ i.total_margin | currency }}</b></td>
                                            <td></td>
                                          </tr>
                                      </tfoot>
                                    </table>
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                          <th>#</th>
                                          <th>Date</th>
                                          <th>Type</th>
                                          <th>Ref No.</th>
                                          <th>Product</th>
                                          <th>Qty</th>
                                          <th>Uom</th>
                                          <th class="text-right">Total HPP</th>
                                          <th class="text-right">Total</th>
                                          <th class="text-right">Profit</th>
                                          <th class="text-right">%</th>
                                      </thead>
                                      <tbody>
                                          <tr v-for="a in i.data_retur" :key="a.id">
                                              <td>
                                                <span>
                                                  <label class="form-checkbox">
                                                    <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selected" v-if="a.type === 'sales'">
                                                    <input type="checkbox" :value="a.id" :disabled="a.check_lock === true" v-model="selectedR" v-else>
                                                  </label>
                                                </span>
                                              </td>
                                              <td>{{ a.date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td>
                                                <span class="badge badge-success" v-if="a.type === 'sales'">{{ a.type }}</span>
                                                <span class="badge badge-warning" v-else>{{ a.type }}</span>
                                              </td>
                                              <td>
                                                <b class="text-ref-sales" @click="showSaleNo(a.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</b>
                                              </td>
                                              <td><b>[{{ a.product_no }}]</b> {{ a.description }}</td>
                                              <td>{{ a.qty}}</td>
                                              <td>{{ a.uom_id }}</td>
                                              <td class="text-right">{{ a.total_cost | currency }}</td>
                                              <td class="text-right">{{ a.total | currency }}</td>
                                              <td class="text-right">
                                                <span class="badge badge-danger" v-if="a.margin < 0">{{ a.margin | currency }}</span>
                                                <span v-else>{{ a.margin | currency }}</span>
                                              </td>
                                              <td class="text-right">
                                                <span class="badge badge-danger" v-if="a.margin_percentage < 0">{{ a.margin_percentage | currency }}</span>
                                                <span v-else>{{ a.margin_percentage | currency }}</span>
                                              </td>
                                          </tr>
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td>{{ i.total_qty_retur | currency }}</td>
                                          <td></td>
                                          <td class="text-right"><b>{{ i.total_cost_retur | currency }}</b></td>
                                          <td class="text-right"><b>{{ i.total_retur | currency }}</b></td>
                                          <td class="text-right"><b>{{ i.total_margin_retur | currency }}</b></td>
                                          <td></td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </div>
                              </div>
                            </div>
                            <div class="tab-pane" id="sales-data-raw">
                              <div class="row">
                                <div class="col-md-12">
                                  <button class="btn btn-sm btn-hard-primary" @click="getJournalSalesRaw">Get Journal</button>
                                </div>
                                <div class="col-md-6">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                    <thead>
                                        <th>Sales No</th>
                                        <th class="text-right">Total Sales</th>
                                        <th class="text-right">Total HPP</th>
                                        <th class="text-right">Total Journal</th>
                                        <th>#</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(a, index) in saleCost" :key="a.ref_no">
                                            <td>{{ a.ref_no }}</td>
                                            <td class="text-right">{{ a.total | currency }}</td>
                                            <td class="text-right">{{ a.total_cost | currency }}</td>
                                            <td class="text-right">
                                              <span v-if="a.total_cost !== a.total_journal" class="badge badge-danger">{{ a.total_journal | currency }}</span>
                                              <span v-else>{{ a.total_journal | currency }}</span>
                                            </td>
                                            <td>
                                              <button class="btn btn-sm btn-hard-primary" @click="getJournalSalesRawSingle(index)">Check</button>
                                              <button class="btn btn-sm btn-soft-primary" @click="setJournalSales(a.ref_id)">Set Journal</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="col-md-6">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                    <thead>
                                        <th>Retur No</th>
                                        <th class="text-right">Total</th>
                                        <th class="text-right">Total HPP</th>
                                        <th class="text-right">Total Journal HPP</th>
                                        <th>#</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(a, index) in returCost" :key="a.ref_no">
                                            <td>{{ a.ref_no }}</td>
                                            <td class="text-right">{{ a.total | currency }}</td>
                                            <td class="text-right">{{ a.total_cost | currency }}</td>
                                            <td class="text-right">
                                              <span v-if="a.total_cost !== a.total_journal" class="badge badge-danger">{{ a.total_journal | currency }}</span>
                                              <span v-else>{{ a.total_journal | currency }}</span>
                                            </td>
                                            <td>
                                              <button class="btn btn-sm btn-hard-primary" @click="getJournalReturRawSingle(index)">Check</button>
                                              <button class="btn btn-sm btn-hard-primary" @click="setJournalReturn(a.ref_id)">Check</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- <pre>{{ saleCost }}</pre> -->
                              </div>
                            </div>
                            <div class="tab-pane" id="sales-product">
                                <div v-for="i in filterData" :key="i.id">
                                    <h5 class="text-center" style="margin-top: 20px"><b>{{ i.name }}</b></h5>
                                    <hr/>
                                    <div class="table-responsive">
                                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                                            <thead>
                                                <th>Product</th>
                                                <th>Type</th>
                                                <th>Qty</th>
                                                <th>Uom</th>
                                                <th class="text-right">HPP</th>
                                                <th class="text-right">Total HPP</th>
                                                <th class="text-right">Total</th>
                                                <th class="text-right">Profit</th>
                                                <th class="text-right">%</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="a in i.groupData" :key="a.product_no">
                                                    <td><b>[{{ a.product_no }}]</b> {{ a.description }}</td>
                                                    <td>{{ a.type }}</td>
                                                    <td>{{ a.qty}}</td>
                                                    <td>{{ a.uom_id }}</td>
                                                    <td class="text-right">{{ a.total_cost / a.qty | currency }}</td>
                                                    <td class="text-right">{{ a.total_cost | currency }}</td>
                                                    <td class="text-right">{{ a.total | currency }}</td>
                                                    <td class="text-right">{{ a.total_margin | currency }}</td>
                                                    <td class="text-right">{{ a.margin_percentage }}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td class="text-right"><b>{{ i.total_cost | currency }}</b></td>
                                                    <td class="text-right"><b>{{ i.total | currency }}</b></td>
                                                    <td class="text-right"><b>{{ i.total_margin | currency }}</b></td>
                                                    <td class="text-right"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane" id="raw-type">
                              <div class="row">
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total HPP Barang Dagangan</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalTypeBarangDagangan | currency }}</span>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total HPP Bahan Baku</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalTypeBahanBaku | currency }}</span>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total HPP Barang Jadi</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalTypeBarangJadi | currency }}</span>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total HPP Barang Setengah Jadi</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalTypeBarangSetengahJadi | currency }}</span>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total HPP</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalTypeBarangDagangan + totalTypeBahanBaku + totalTypeBarangSetengahJadi + totalTypeBarangJadi | currency }}</span>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-for="i in dataRaw2" :key="i.id">
                                <h5 class="text-center" style="margin-top: 20px"><b>{{ i.id }} - {{ i.name }}</b></h5>
                                <hr/>
                                <div class="table-responsive">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                    <thead>
                                        <th>Date</th>
                                        <th>Type</th>
                                        <th>Ref No.</th>
                                        <th>Product</th>
                                        <th>Qty</th>
                                        <th>Uom</th>
                                        <th class="text-right">HPP</th>
                                        <th class="text-right">Total HPP</th>
                                        <th class="text-right">Total</th>
                                        <th class="text-right">Profit</th>
                                        <th class="text-right">%</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="a in i.data" :key="a.id">
                                            <td>{{ a.date }}</td>
                                            <td>
                                              <span class="badge badge-success" v-if="a.type === 'sales'">{{ a.type }}</span>
                                              <span class="badge badge-warning" v-else>{{ a.type }}</span>
                                            </td>
                                            <td>
                                              <b class="text-ref-sales" @click="showSaleNo(a.ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ a.ref_no }}</b>
                                            </td>
                                            <td><b>[{{ a.product_no }}]</b> {{ a.description }}</td>
                                            <td>{{ a.qty}}</td>
                                            <td>{{ a.uom_id }}</td>
                                            <td class="text-right">{{ a.cost | currency }}</td>
                                            <td class="text-right">
                                              <span v-if="a.type == 'retur'">({{ a.total_cost | currency }})</span>
                                              <span v-else>{{ a.total_cost | currency }}</span>
                                            </td>
                                            <td class="text-right">
                                              <span v-if="a.type == 'retur'">({{ a.total | currency }})</span>
                                              <span v-else>{{ a.total | currency }}</span>
                                            </td>
                                            <td class="text-right">
                                              <span class="badge badge-danger" v-if="a.margin < 0">{{ a.margin | currency }}</span>
                                              <span v-else>{{ a.margin | currency }}</span>
                                            </td>
                                            <td class="text-right">
                                              <span class="badge badge-danger" v-if="a.margin_percentage < 0">{{ a.margin_percentage | currency }}</span>
                                              <span v-else>{{ a.margin_percentage | currency }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td>{{ i.total_qty | currency }}</td>
                                          <td></td>
                                          <td class="text-right"><b>{{ i.total_cost | currency }}</b></td>
                                          <td class="text-right"><b>{{ i.total | currency }}</b></td>
                                          <td class="text-right"><b>{{ i.total_margin | currency }}</b></td>
                                          <td></td>
                                        </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div class="tab-pane" id="summary">
                              <div class="table-responsive">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                          <th>Product</th>
                                          <th class="text-center">Qty</th>
                                          <th>Uom</th>
                                          <th class="text-right">Total COGS</th>
                                          <th class="text-right">Total</th>
                                          <th class="text-right">Profit</th>
                                          <th class="text-right">%</th>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(a, index) in groupSummary" :key="index">
                                          <td><b>[{{ a.product_no }}]</b> {{ a.description }}</td>
                                          <td class="text-center">{{ a.qty }}</td>
                                          <td>{{ a.uom_id }}</td>
                                          <td class="text-right">{{ a.total_cost | currency }}</td>
                                          <td class="text-right">{{ a.total | currency }}</td>
                                          <td class="text-right">{{ a.total_margin | currency }}</td>
                                          <td class="text-right">{{ a.margin_percentage }}</td>
                                        </tr>
                                      </tbody>
                                  </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <SaleModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { reportTransactionUrl, salesUrl, getHeader, sale2Url, returnUrl } from '@/config'
import DatePicker from 'vue2-datepicker'
import SaleModal from '@/components/sales/SaleModal.vue'

export default {
  name: 'SaleReportProduct',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker,
    SaleModal
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getUrcFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      saleCost: [],
      returCost: [],
      filterType: [],
      loadingSales: true,
      selected: [],
      selectedR: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      dataRaw2: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser
    }),
    totalTypeBahanBaku () {
      var array = this.dataRaw2.filter(d => d.id === 1 || d.id === 2)
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cost)
      }
      return sum
    },
    totalTypeBarangJadi () {
      var array = this.dataRaw2.filter(d => d.id === 3 || d.id === 4)
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cost)
      }
      return sum
    },
    totalTypeBarangDagangan () {
      var array = this.dataRaw2.filter(d => d.id === 5)
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cost)
      }
      return sum
    },
    totalTypeBarangSetengahJadi () {
      var array = this.dataRaw2.filter(d => d.id === 6)
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cost)
      }
      return sum
    },
    totalMargin () {
      var sum = 0
      sum = this.totalSales - this.totalRetur - (this.totalCOGS - this.totalCOGSRetur)
      return sum
    },
    totalMarginPlus () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data
        for (let a = 0; a < arr.length; a++) {
          if (arr[a].margin >= 0) {
            sum += parseFloat(arr[a].margin)
          }
        }
      }
      return sum
    },
    totalMarginMinus () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data
        for (let a = 0; a < arr.length; a++) {
          if (arr[a].margin < 0) {
            sum += parseFloat(arr[a].margin)
          }
        }
      }
      return sum
    },
    totalCOGS () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data
        for (let b = 0; b < arr.length; b++) {
          if (arr[b].type === 'sales') {
            sum += parseFloat(arr[b].total_cost)
          }
        }
      }
      return sum
    },
    totalCOGSRetur () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data_retur
        for (let b = 0; b < arr.length; b++) {
          if (arr[b].type === 'retur') {
            sum += parseFloat(arr[b].total_cost)
          }
        }
      }
      return sum
    },
    totalSales () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data
        for (let b = 0; b < arr.length; b++) {
          if (arr[b].type === 'sales') {
            sum += parseFloat(arr[b].total)
          }
        }
      }
      return sum
    },
    totalRetur () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data_retur
        for (let b = 0; b < arr.length; b++) {
          if (arr[b].type === 'retur') {
            sum += parseFloat(arr[b].total)
          }
        }
      }
      return sum
    },
    salesRaw () {
      var array = this.dataRaw
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var data = array[i].data
        for (let b = 0; b < data.length; b++) {
          loop.push(data[b])
        }
      }
      return loop
    },
    groupSales () {
      var result = []
      if (this.salesRaw.length > 0) {
        this.salesRaw.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.ref_no
          if (!res[key]) {
            res[key] = {
              ref_no: value.ref_no,
              total: parseFloat(value.total),
              totalCost: parseFloat(value.total_cost),
              totalJournal: parseFloat(value.total_journal)
            }
            result.push(res[key])
          } else {
            res[key].total = parseFloat(res[key].total) + parseFloat(value.total)
            res[key].totalCost = parseFloat(res[key].totalCost) + parseFloat(value.total_cost)
            res[key].totalJournal = parseFloat(res[key].totalJournal) + parseFloat(value.total_journal)
          }
          return res
        }, {})
      }
      var col = 'ref_no'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    returRaw () {
      var array = this.dataRaw
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var data = array[i].data_retur
        for (let b = 0; b < data.length; b++) {
          loop.push(data[b])
        }
      }
      return loop
    },
    groupRetur () {
      var result = []
      if (this.returRaw.length > 0) {
        this.returRaw.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.ref_no
          if (!res[key]) {
            res[key] = {
              ref_no: value.ref_no,
              total: parseFloat(value.total)
            }
            result.push(res[key])
          } else {
            res[key].total = parseFloat(res[key].total) + parseFloat(value.total)
          }
          return res
        }, {})
      }
      var col = 'ref_no'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    lossSummary () {
      var array = this.groupSummary
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].total_margin < 0) {
          sum += parseFloat(array[i].total_margin)
        }
      }
      return sum
    },
    profitSummary () {
      var array = this.groupSummary
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].total_margin > 0) {
          sum += parseFloat(array[i].total_margin)
        }
      }
      return sum
    },
    groupSummary () {
      var loop = []
      var array = this.dataRaw
      for (let a = 0; a < array.length; a++) {
        var groupData = array[a].groupData
        for (let b = 0; b < groupData.length; b++) {
          loop.push(groupData[b])
        }
      }
      var col = 'total_margin'
      var ascending = false
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return loop.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    totalIncome () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type === 'income')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalOutcome () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type === 'outcome')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalTransfer () {
      var sum = 0
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (this.filterType[i] === d.type) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    },
    filterData2: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (this.filterType[i] === d.type) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async setJournalReturn (id) {
      this.$Progress.start()
      this.loader.isLoading = true
      await axios.get(returnUrl + '/journal-sales/' + id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async setJournalSales (id) {
      this.$Progress.start()
      this.loader.isLoading = true
      console.log(salesUrl + '/journal-stock-out/' + id)
      await axios.get(salesUrl + '/journal-stock-out/' + id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getJournalSalesRawSingle (index) {
      var data = this.saleCost[index]
      var obj = {
        sale_no: data.ref_no
      }
      console.log(obj)
      console.log(salesUrl + '/get-journal-stock-out')
      await axios.post(salesUrl + '/get-journal-stock-out', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          console.log(response.data.total)
          data.total_journal = parseFloat(response.data.total)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message + ' ' + data.ref_no, 'error')
          throw error
        })
    },
    async getJournalReturRawSingle (index) {
      var data = this.returCost[index]
      var obj = {
        return_no: data.ref_no
      }
      console.log(obj)
      console.log(returnUrl + '/get-journal')
      await axios.post(returnUrl + '/get-journal', obj, { headers: getHeader() })
        .then(response => {
          data.total_journal = response.data.total
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getJournalSalesRaw () {
      var array = this.saleCost
      for (let i = 0; i < array.length; i++) {
        await this.getJournalSalesRawSingle(i)
      }
    },
    async uncheckReportPayment (id, refNo) {
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === id) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: refNo
        }
        await axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    async checkDetail () {
      var array = this.selected
      var obj = {
        data: array
      }
      console.log(obj)
      if (array.length > 0) {
        await axios.post(salesUrl + '/setCheck', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.message)
          })
          .catch(error => {
            this.$swal('Error', error.message, 'error')
            throw error
          })
      }

      var array2 = this.selectedR
      var obj2 = {
        data: array2
      }
      console.log(obj2)
      if (array.length > 0) {
        await axios.post(returnUrl + '/setCheck', obj2, { headers: getHeader() })
          .then(response => {
            console.log(response.message)
          })
          .catch(error => {
            this.$swal('Error', error.message, 'error')
            throw error
          })
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(salesUrl + '/report-laba-sales-by-product')
      await axios.post(salesUrl + '/report-laba-sales-by-product', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          var array = response.data.data
          for (let i = 0; i < array.length; i++) {
            var data = array[i].data
            var retur = array[i].data_retur
            for (let j = 0; j < data.length; j++) {
              if (data[j].is_check === true) {
                this.selected.push(data[j].id)
              }
            }
            for (let k = 0; k < retur.length; k++) {
              if (retur[k].is_check === true) {
                this.selectedR.push(retur[k].id)
              }
            }
          }
          console.log(response.data.groupSales)
          this.saleCost = response.data.groupSales
          this.returCost = response.data.groupRetur
        })
        .catch(error => {
          this.$swal('Error', error.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.getJournalSalesRaw()
    },
    async getType () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(salesUrl + '/report-laba-sales-by-product-type')
      await axios.post(salesUrl + '/report-laba-sales-by-product-type', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw2 = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async processReport () {
      this.$Progress.start()
      this.loader.isLoading = true
      for (let c = 0; c < this.selected.length; c++) {
        var data = this.dataRaw.find(d => d.id === this.selected[c])
        var obj = {
          cash_id: data.id,
          company_no: data.company_no,
          report_date: data.cash_date
        }
        await axios.post(reportTransactionUrl + '/create-cash-on-hand', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        format: type,
        data: this.dataRaw,
        begin: begin,
        end: end
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(sale2Url + '/sale-by-category', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
